/**
 * Shared card style for Match Details screen – one definition for section cards,
 * Over/Under block, and Correct Score picker. Theme-driven.
 */

import { Platform } from 'react-native';
import type { ThemeColors } from '../../../src/theme/themes';

export const CARD_SHADOW = Platform.select({
  ios: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
  },
  android: {
    elevation: 6,
  },
});

/** Single gamified card style: accent border, shadow, rounded. Use for all section cards. */
export const getMatchDetailsCardStyle = (theme: ThemeColors) => ({
  backgroundColor: theme.background.card,
  borderRadius: 16,
  padding: 18,
  marginBottom: 14,
  borderWidth: 1,
  borderColor: theme.gray[200],
  borderLeftWidth: 4,
  borderLeftColor: theme.primary,
  overflow: 'hidden' as const,
  ...CARD_SHADOW,
});
